<template>
  <div :class="{ 'show-done': showDone, 'is-complete': isOrderCompleted }">
    <div class="warehouse-order-article -actions" v-if="!isOrderCompleted">
      <OrderCompleteAllSwitch class="complete-all" />
      <div class="toggle">
        <span
            v-if="!hasNoPartialDelivery"
            @click="showDone = !showDone"
            class="small-hover-link"
        >
          <template v-if="showDone">
            Gelieferte ausblenden
          </template>
          <template v-else>
            Gelieferte einblenden
          </template>
        </span>
      </div>
    </div>

    <template v-if="hasStandardItems">
      <OrderArticleHeader class="-highlighted"/>


      <OrderArticleWithResidents
          v-for="article in standardItems"
          :key="article.id"
          :article="article"
          :is-complete="isOrderCompleted"
      />
    </template>
    <template v-if="hasCollectiveItems">
      <OrderArticleSpacer>
        <span class="icon-gemeinschaftsartikel mr-4"></span>
        <span class="mt-1 text--darkestgrey">
          {{ $t('sl.warehouse.sections.collective-articles.title') }}
        </span>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="icon-informationen text--darkestgrey ml-2"></span>
          </template>
          <div style="max-width: 380px;" v-html="$t('sl.warehouse.sections.collective-articles.text')">
          </div>
        </v-tooltip>
      </OrderArticleSpacer>

      <OrderArticleHeader class="-highlighted -inline"/>

      <OrderArticleWithResidents
          v-for="article in collectiveItems"
          :key="article.id"
          :article="article"
          :is-complete="isOrderCompleted"
      />
    </template>

    <OrderArticleFooter/>
  </div>
</template>

<script>
import {orderViewMixin} from "@/mixins/SmartLogistics/ModelC/orderView";
import OrderArticleHeader from "@/components/SmartLogistics/Warehouse/Partials/OrderArticleHeader.vue";
import OrderArticleWithResidents from "@/components/SmartLogistics/Warehouse/Order/OrderArticleWithResidents.vue";
import OrderArticle from "@/components/SmartLogistics/Warehouse/Partials/OrderArticle.vue";
import {internalOrderMixin} from "@/mixins/SmartLogistics/ModelC/internalOrder";
import OrderArticleFooter from "@/components/SmartLogistics/Warehouse/Partials/OrderArticleFooter.vue";
import OrderArticleSpacer from "@/components/SmartLogistics/Warehouse/Partials/OrderArticleSpacer.vue";
import OrderCompleteAllSwitch from "@/components/SmartLogistics/Warehouse/Order/OrderCompleteAllSwitch.vue";

export default {
  name: 'ArticleResidentView',
  components: {
    OrderCompleteAllSwitch,
    OrderArticleSpacer, OrderArticleFooter, OrderArticle, OrderArticleWithResidents, OrderArticleHeader},
  mixins: [internalOrderMixin, orderViewMixin],

  data() {
    return {
      showDone: true,
    }
  },

  computed: {
    hasNoPartialDelivery() {
      return this.order.status === 'new'
    },

    orderSuggestion() {
      return this.order.order_suggestion.filter(i => i.quantity > 0)
    },

    hasStandardItems() {
      if (!this.showDone) {
        let standardItemsArticleNumbers = this.standardItems.map(item => item.artikelNrLAG);
        return this.standardItems.length > 0 && this.orderSuggestion.some(item => {
          if (!standardItemsArticleNumbers.includes(item.artikelNrLAG)) {
            return false;
          }
          let currentlyPicked = this.currentlyPickedFor(item.artikelNrLAG, this.entityType(item.id), this.entityId(item.id));
          return currentlyPicked.orderedQuantity !== currentlyPicked.deliveredBefore;
        })
      }
      return this.standardItems.length > 0
    },

    hasCollectiveItems() {
      if (!this.showDone) {
        let collectiveItemsArticleNumbers = this.collectiveItems.map(item => item.artikelNrLAG);
        return this.collectiveItems.length > 0 && this.orderSuggestion.some(item => {
          if (!collectiveItemsArticleNumbers.includes(item.artikelNrLAG)) {
            return false;
          }
          let currentlyPicked = this.currentlyPickedFor(item.artikelNrLAG, this.entityType(item.id), this.entityId(item.id));
          return currentlyPicked.orderedQuantity !== currentlyPicked.deliveredBefore;
        })
      }
      return this.collectiveItems.length > 0
    }
  },
  methods: {
    isLivingUnit(id) {
      return id.toString().startsWith('lu_')
    },

    entityType(id) {
      return this.isLivingUnit(id) ? 'living-unit' : 'resident'
    },

    entityId(id) {
      return id.toString().replace('lu_', '')
    },
  }
}
</script>
